export default {
  'ele-form': {
    required: '必填',
    backBtnText: '返回',
    resetBtnText: '重置',
    submitBtnText: '提交',
    cancelBtnText: '取消',
    mockBtnText: '模拟数据',
    select: '请选择',
    submitBtnTextInline: '查询',
    formError: '表单填写错误',
    input: '请输入',
    time: '请选择时间',
    date: '选择日期',
    week: '请选择周',
    year: '请选择年',
    weekFormat: 'yyyy 第 WW 周',
    startDate: '开始日期',
    endDate: '结束日期',
    startTime: '开始时间',
    endTime: '结束时间',
    dates: '选择一个或多个日期',
    month: '选择月',
    tagError: '已存在',
    upload: {
      error: '上传出错了, 请重试!',
      size: '上传图片大小不能超过',
      action: '请传入请求地址 action 属性!',
      imageType: '上传文件格式不正确, 请上传图片文件!'
    }
  }
}
